import styled from '@emotion/styled'

export const AIHStack = styled.div`
  display: flex;
  flex-direction: row;
  gap: 2rem;
  width: 100%;
  > * {
    flex: 1;
  }
`

export const HStack = styled.div`
  padding-top: 0.6rem;
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  align-items: flex-start;
  width: 100%;
  margin-bottom: 1.2rem;
`
